import React from "react";
import "./ModalHeaderText.css";

const ModalHeaderText = (props) => {
  const { LoginHeading } = props;
  return (
    <div>
      <h3 className="modal-header-text">{LoginHeading}</h3>
      <div className="modal-header-text-line"></div>
    </div>
  );
};

export default ModalHeaderText;
